// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { Modal } from 'components/atoms/Modal';
import Portal from 'components/atoms/Portal';
import { TraceDataInfo } from 'types/purchase';
import styles from './PurchaseTraceDetailModal.module.scss';
import { IconCloseTablet } from 'components/atoms/icons/IconCloseTablet';
import { IconDownload } from 'components/atoms/icons/IconDownload';
import { hideLastCharacters, normalizeNumber } from 'util/commons';
import { useTranslation } from 'react-i18next';
import { OperatorType } from 'util/Enums';

type PurchaseTraceDetailModalProps = {
  stage: OperatorType;
  info: TraceDataInfo;
  onClose?: () => void;
  onDownload?: () => void;
};

const PurchaseTraceDetailModal: React.FC<PurchaseTraceDetailModalProps> = ({
  stage,
  info,
  onClose,
  onDownload,
}) => {
  const { t } = useTranslation();

  return (
    <Portal>
      <Modal
        centered
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        contentClassName={styles.modalContent}
      >
        <div className={styles.header}>
          <h2>{t('purchase_page.trace_data_detail.modal_detail.title')}</h2>
          <IconCloseTablet onClick={onClose} />
        </div>

        <div className={styles.body}>
          <div className={styles.summarizedInfo}>
            <div className={styles.infoRow}>
              <p className={styles.siteName}>{info.siteName}</p>
              <div className={styles.downloadIcon}>
                <IconDownload strokeColor="#86ea5c" onClick={onDownload} />
              </div>
            </div>

            <div className={styles.infoRow}>
              {[
                {
                  label: t('common.weight'),
                  value: `${normalizeNumber({
                    value: info.totalWeight,
                  })}kg`,
                },
                {
                  label: 'ID',
                  value: `${normalizeNumber({
                    value: info.data.length,
                  })}${t('qr_scan.items')}`,
                },
              ].map(({ label, value }, index) => (
                <div key={index} className={styles.infoCard}>
                  <p className={styles.infoLabel}>{label}</p>
                  <p className={styles.infoValue}>{value}</p>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.tableWrapper}>
            <table className={styles.detailTable}>
              <thead>
                <tr>
                  <th>{t('purchase_page.histories.registration_id')}</th>
                  <th>
                    {stage === OperatorType.Emissions
                      ? t('purchase_page.trace_data_detail.description')
                      : t('purchase_page.trace_data_detail.material_name')}
                  </th>
                  <th>{t('common.weight')}</th>
                </tr>
              </thead>

              <tbody>
                {info.data.map((item, index) => (
                  <tr key={index}>
                    <td>
                      {stage === OperatorType.Emissions
                        ? hideLastCharacters(item.id)
                        : item.id}
                    </td>
                    <td>{item.description}</td>
                    <td>{normalizeNumber({ value: item.weight })}kg</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
    </Portal>
  );
};

export default PurchaseTraceDetailModal;
